import React from 'react';
import { HashRouter } from 'react-router-dom';

import { Authenticator, translations } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import RootPage from '@components/pages/RootPage';
import MessageDialog from '@components/parts/dialog/MessageDialog';
import { ThemeProvider as MUIThemeProvider } from '@mui/material/styles';
import { Amplify } from 'aws-amplify';
import { I18n } from 'aws-amplify/utils';
import dayjs from 'dayjs';
import 'dayjs/locale/ja';
import customParseFormat from 'dayjs/plugin/customParseFormat';

import amplifyTranslations from '@config/amplifyTranslations';
import amplifyConfig from '@config/awsconfig';
import muiMain from '@theme/muiMain';

import './App.css';

/* 日本語設定 */
I18n.putVocabularies(Object.assign(translations));
// 追加分
I18n.putVocabularies(amplifyTranslations);
I18n.setLanguage('ja');

/* AWS情報の設定 */
Amplify.configure(amplifyConfig, {
  Storage: {
    S3: {
      // プレフィックス削除
      prefixResolver: async () => ''
    }
  }
});

/* ロケールの設定 */
dayjs.locale('ja');
dayjs.extend(customParseFormat);
const App = () => (
  <div>
    <HashRouter>
      <MUIThemeProvider theme={muiMain}>
        <Authenticator.Provider>
          <MessageDialog />
          <RootPage />
        </Authenticator.Provider>
      </MUIThemeProvider>
    </HashRouter>
  </div>
);

export default App;
